import { render, staticRenderFns } from "./CampaignLinker.vue?vue&type=template&id=312d572b"
import script from "./CampaignLinker.vue?vue&type=script&lang=js"
export * from "./CampaignLinker.vue?vue&type=script&lang=js"
import style0 from "./CampaignLinker.vue?vue&type=style&index=0&id=312d572b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports